/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneGameModuleConfig} from "./TombstoneGameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TombstoneIndividualWPController} from "./winpresentation/individual/TombstoneIndividualWPController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TombstoneSpinController} from "./spin/TombstoneSpinController";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

export class TombstoneNoMercy extends SlotGame {
    public static isActionSpinsActive:boolean = false;
    public static individualWin:TombstoneIndividualWPController;
    public static spinController:TombstoneSpinController;

    private skinner: Skinner;

    constructor() {
        super(TombstoneGameModuleConfig.instance);
        const validSkins: string[] = [
            "sweep",
            "us-nonfree"
        ]
        this.skinner = new Skinner(validSkins);
    }

    async init(): Promise<NolimitPlugin> {
        await super.init();
        this.handleSweepAndUSCTInit();
        return Promise.resolve(this);
    }

    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "bonus/"
            };
            if (this.skinner.skinId != undefined) {
                if(this.skinner.skinId != "us-nonfree"){
                    data.skinPath = `../resources/images/${this.skinner.skinId}/`;
                }
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            resolve(paytableString);
        });
    }

    private handleSweepAndUSCTInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.api.gameClientConfiguration.isSet) {
            if (SlotGame.api.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
            if (SlotGame.api.gameClientConfiguration.replaceWordFree){
                this.skinner.skinId = "us-nonfree";
            }
        } else {
            SlotGame.api.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.api.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
                if (SlotGame.api.gameClientConfiguration.replaceWordFree){
                    this.skinner.skinId = "us-nonfree";
                }
            })

        }
    }

    private handleSweepAndUSCTGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();
            if(this.skinner.skinId==="us-nonfree"){
                replaceMap.set("freespinretrigger/1FS", "1FS.png");
                replaceMap.set("freespinretrigger/2FS", "2FS.png");
            }

            if(this.skinner.skinId==="sweep"){
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("BOOSTED_BET_WILD", "BOOSTED_BET_WILD.png");
                replaceMap.set("page4", "BOOSTED_BET.png");
                replaceMap.set("page5", "BOOSTED_BET_WILD.png");
                replaceMap.set("Xbet_On", "Xbet_On.png");
            }

            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    async getReady(): Promise<NolimitPlugin> {
        await super.getReady();
        await this.handleSweepAndUSCTGetReady();
        return Promise.resolve(this);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M5",
                    "L4",
                    "L1",
                    "L3",
                    "L2"
                ],
                [
                    "M2",
                    "M5",
                    "L2",
                    "L1",
                    "L4"
                ],
                [
                    "L3",
                    "L2",
                    "M1",
                    "L3",
                    "L4"
                ],
                [
                    "M3",
                    "L1",
                    "M4",
                    "L3",
                    "L1"
                ],
                [
                    "M5",
                    "L4",
                    "B2",
                    "L3",
                    "M5"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "L1",
                    "L3"
                ],
                [
                    "M5",
                    "L2",
                    "L1"
                ],
                [
                    "L2",
                    "M1",
                    "L3"
                ],
                [
                    "L1",
                    "M4",
                    "L3"
                ],
                [
                    "X",
                    "B",
                    "L3"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "superFreespinTriggeredThisSpin": false,
            "bonusTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinMultiplierBefore": 1,
            "freespinMultiplierAfter": 1,
            "overlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpin": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L1",
                    "L2",
                    "M4"
                ],
                [
                    "L4",
                    "M1",
                    "M4"
                ],
                [
                    "S",
                    "M3",
                    "M4"
                ],
                [
                    "L3",
                    "L2",
                    "S"
                ],
                [
                    "L3",
                    "L1",
                    "M4"
                ]
            ],
            "numberOfBonusSpinsPlayed": 0,
            "bonusSpinsLeft": 0,
            "bonusPositions": [
                -1,
                -1,
                -1,
                -1,
                1
            ],
            "stickyWilds": [
                false,
                false,
                false,
                false,
                false
            ],
            "multiplierOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ]
        };
    }

    getReadyToStart():Promise<NolimitPlugin> {
        SlotGame.api.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:any)=>{
            if (data === true){
                TombstoneNoMercy.isActionSpinsActive = true;
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.BEFORE_START));
                TombstoneNoMercy.individualWin.abort();
                TombstoneNoMercy.spinController.clear();
            } else {
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.BEFORE_START));
                TombstoneNoMercy.isActionSpinsActive = false;
                TombstoneNoMercy.spinController.clear();
            }
        });

        return super.getReadyToStart();
    }
}